'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.now = now;
function now() {
  return typeof performance !== 'undefined' && performance && performance.now ? performance.now() : -1;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/web-bi-logger/dist/src/lib/performance.js
// module id = 182
// module chunks = 0